<template>
  <q-card>
    <q-card-section>

    </q-card-section>

    <q-card-actions>
      <q-btn label="شروع اسکن" @click="startScan" color="primary"/>
      <q-btn label="انصراف از اسکن" color="red" flat/>
    </q-card-actions>
  </q-card>
</template>

<script>

import {
  BarcodeScanner,
  BarcodeFormat,
} from '@capacitor-mlkit/barcode-scanning';

export default {
  name: 'QRScanner',
  components: {
  },
  methods: {
    onDetect(detectedCodes) {
      console.log(detectedCodes)
    },
    async startScan() {
      await this.requestPermissions()
      document.querySelector('body')?.classList.add('barcode-scanner-active');
      await BarcodeScanner.addListener(
          'barcodeScanned',
          async result => {
            console.log(result.barcode);
          },
      );
      await BarcodeScanner.startScan();
    }
    ,
    async stopScan() {
      document.querySelector('body')?.classList.remove('barcode-scanner-active');
      await BarcodeScanner.removeAllListeners();
      await BarcodeScanner.stopScan();
    },
    async scanSingleBarcode() {
      await this.requestPermissions()
      document.querySelector('body')?.classList.add('barcode-scanner-active');
      const listener = await BarcodeScanner.addListener(
          'barcodeScanned',
          async result => {
            await listener.remove();
            document
                .querySelector('body')
                ?.classList.remove('barcode-scanner-active');
            await BarcodeScanner.stopScan();
            console.log(result.barcode);
          },
      );
      await BarcodeScanner.startScan();
    },
    async scan() {
      const {barcodes} = await BarcodeScanner.scan({
        formats: [BarcodeFormat.QrCode],
      });
      return barcodes;
    },
    async isSupported() {
      const {supported} = await BarcodeScanner.isSupported();
      return supported;
    },
    async enableTorch() {
      await BarcodeScanner.enableTorch();
    },
    async disableTorch() {
      await BarcodeScanner.disableTorch();
    },
    async toggleTorch() {
      await BarcodeScanner.toggleTorch();
    },
    async isTorchEnabled() {
      const {enabled} = await BarcodeScanner.isTorchEnabled();
      return enabled;
    },
    async isTorchAvailable() {
      const {available} = await BarcodeScanner.isTorchAvailable();
      return available;
    },
    async openSettings() {
      await BarcodeScanner.openSettings();
    },
    async isGoogleBarcodeScannerModuleAvailable() {
      const {available} =
          await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
      return available;
    },
    async installGoogleBarcodeScannerModule() {
      await BarcodeScanner.installGoogleBarcodeScannerModule();
    },
    async checkPermissions() {
      const {camera} = await BarcodeScanner.checkPermissions();
      return camera;
    },
    async requestPermissions() {
      const {camera} = await BarcodeScanner.requestPermissions();
      return camera;
    }
  }
}
</script>
<style>
body.barcode-scanner-active {
  visibility: hidden;
}

.barcode-scanner-modal {
  visibility: visible;
}
</style>